// Pure-string preprocess used by MarkdownText before the markdown pipeline.
// Pure function so unit tests don't need to import any markdown packages.

/**
 * Rewrite the system-prompt's <plan>…</plan> block into a Markdown blockquote
 * with a "📋 Plan" label. Without this, react-markdown sees the literal
 * angle-bracket tags and leaks them into the bubble (we don't run rehype-raw,
 * so unknown HTML elements aren't actually rendered as DOM).
 *
 * Blank lines around the body let remark re-parse the inner content so
 * ordered lists, code spans, etc. inside the plan still render correctly.
 * Each non-empty line gets a "> " prefix to extend the blockquote across
 * the whole plan body.
 *
 * @param {string | null | undefined} text - raw assistant_text from kyoto.
 * @returns the rewritten text, or the input unchanged if falsy / no <plan>.
 */
export function preprocessPlanBlock(text) {
  if (!text) return text;
  return text.replace(/<plan>([\s\S]*?)<\/plan>/g, (_match, body) => {
    const quoted = body
      .trim()
      .split("\n")
      .map((line) => (line.length ? `> ${line}` : ">"))
      .join("\n");
    return `> **📋 Plan**\n>\n${quoted}`;
  });
}
